import { render, staticRenderFns } from "./EventSelection.vue?vue&type=template&id=55a480ef&"
import script from "./EventSelection.vue?vue&type=script&lang=js&"
export * from "./EventSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports